module.exports = __webpack_public_path__ + "static/media/hall-P6.dbaf4237.svg";